import { Injectable } from '@angular/core';
import { AccommodationQuoteInput, CourseQuoteInput, FormType, QuoteInput, QuoteInputForm } from '@lx/quote-tool/shared/types';
import { getTuitionWeeks, getValidAccommodations, getValidCourses } from '@lx/quote-tool/shared/data-access/quote';
import { QuoteRequestProductApiDto } from '@lx/shared/api';

@Injectable({
  providedIn: 'root',
})
export class QuoteInputFormMapper {
  private convertToQuoteRequestProductApiDto = ({ code, startDate, weeks }: CourseQuoteInput | AccommodationQuoteInput) =>
    ({ code, startDate, weeks } as QuoteRequestProductApiDto);

  mapQuoteInputFormToQuoteRequestDto(quoteInput: QuoteInputForm) {
    const validateLevel = this.shouldValidateLevel(quoteInput);
    const courses: CourseQuoteInput[] = getValidCourses(quoteInput, validateLevel);

    return {
      schoolCode: quoteInput.school,
      schoolType: quoteInput.schoolType,
      country: quoteInput.country?.name,
      city: quoteInput.destinationCity?.name,
      courseType: courses?.length && courses[0]?.courseType?.name,
      accommodationType: quoteInput.accommodationType,
      tuitionWeeks: getTuitionWeeks(quoteInput, validateLevel),
      courseLevel: courses?.length && courses[0].level,
      courses: courses.map(this.convertToQuoteRequestProductApiDto),
      // First course would be the earliest, as in the following ones dates are restricted by the first one
      startDate: courses?.length && courses[0]?.startDate,
      currencyCode: quoteInput.destinationCurrency,
      accommodations: getValidAccommodations(quoteInput).map(this.convertToQuoteRequestProductApiDto),
      supplements: quoteInput.supplements || [],
      bookingDate: null,
    };
  }

  /**
   * Check if the level should be validated. If the form is a price request, then the level SHOULD NOT be validated.
   */
  private shouldValidateLevel(quoteInput: QuoteInput): boolean {
    return quoteInput.formType !== FormType.PRICE_REQUEST;
  }
}
